import { h, Fragment } from 'preact';
import Image from 'utils/image';
import clsx from 'clsx';
import { useMemo } from 'preact/hooks';

const ProductSwatch = ({
  product,
  options,
  selected,
  onChange,
  isQuickView,
  isLookOverlay,
}) => {
  const isUnAvailable = useMemo(() => {
    if (
      options.filter((option) => option.value).length === product.options.length
    ) {
      let variant = false;
      if (product.options.length > 1) {
        const selectedOptions = Object.fromEntries(
          options
            .filter(
              (option) =>
                option.name.trim().toLowerCase() ===
                window.TMW.Strings.product.options.size,
            )
            .map((option) => [option.name, option.value]),
        );
        
        variant = product.variants.find((item) =>
          item.selectedOptions.some(
            (option) => option.value === selectedOptions[option.name],
          ),
        );
      }
      else {
        variant = product.variants.find((item) =>
          item.selectedOptions.some(
            (option) => option.value === options[0].value,
          ),
        );
      }

      if (variant) {
        return !variant.availableForSale;
      }
      return true;
    }
    return !product.availableForSale;
  }, [options, product]);

  const className =
    isQuickView || isLookOverlay
      ? clsx(
          'w-[15px] h-[15px] rounded-full border-black bg-clip-content box-content bg-grey-700',
          {
            'p-2 border ': selected,
          },
        )
      : clsx(
          'lc:rounded-4 overflow-hidden border-transparent lc:border ml:border-b ml:pb-12 w-[calc((100%-25px)/6)] lc:hover:border-black ml:hover:border-black',
          {
            '!border-black': selected,
            '[&_img]:opacity-20': isUnAvailable,
          },
        );
  return (
    <button className={className} onClick={() => onChange(product)}>
      {isQuickView || isLookOverlay ? (
        <>
          {!!product.swatchImage?.reference?.image && (
            <Image
              {...product.swatchImage.reference.image}
              classes="object-cover h-full w-full rounded-full"
              lazyLoad={false}
            />
          )}
        </>
      ) : (
        <Image
          {...product.images[0]}
          srcWidths={{ sm: 100 }}
          classes="w-full h-auto block"
          lazyLoad={false}
        />
      )}
    </button>
  );
};

export default ProductSwatch;
